<div>
  <h1 class="mb8">
    Let’s start creating <br/>your <span>website with AI</span>
  </h1>
  <h4 class="mb20">
    Answer a few questions and our AI will generate your<br/> content and images based on your requirements.
  </h4>

  <div class="sign-up-with-hubspot__form" [formGroup]="hubspotForm">
    <div class="ds-input-wrap">
      <span class="ds-input-label mt0 mb0">Write your email address</span>
      <input type="text" class="ds-input-black mt6" placeholder="Email address"
             formControlName="email"
             [ngClass]="{'error': serverErrors || (hubspotForm?.controls?.email?.invalid
             && ((hubspotForm?.controls?.email?.touched && !hubspotForm?.controls?.email?.errors['required']) || loading))}">
      <span class="ds-input-error-msg" *ngIf="hubspotForm?.controls?.email?.invalid
             && ((hubspotForm?.controls?.email?.touched && !hubspotForm?.controls?.email?.errors['required']) || loading)">{{'text_invalidEmail' | dbText}}</span>
      <span class="ds-input-error-msg" *ngIf="!!serverErrors">{{serverErrors?.message}}</span>
    </div>
  </div>

  <div class="create-ai-assistant-form-view__action-wrap first-step mt30">
    <div class="db-navigation-text">
    </div>

    <button class="ds-btn-black rectangle"
            [ngClass]="{'ds-btn-disabled': !!loading || hubspotForm?.controls?.email?.value === ''}"
            (click)="checkUserExists()">
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      <span *ngIf="!loading">Next</span>
    </button>

  </div>
</div>

<div class="create-ai-image-wrap">
  <div class="create-ai-image"></div>
</div>
